import { TranslationKey } from "types";

export enum ExtendedTabId {
  DigitalSignage = "digital-signage",
  EvCharging = "ev-charging",
  PremiumAudio = "premium-audio",
  ControlPlane = "control-plane",
  IndependentGateways = "independent-gateways",
  CompactCameras = "compact-cameras",
  AIEnhancements = "ai-enhancements",
  Doorbells = "doorbells",
  SuperLink = "superlink",
  FloodLight = "floodlight",
  Express = "express",
  DreamWall = "dream-wall",
  DreamRouter = "dream-router",
  DeviceBridge = "device-bridge",
  BuildingBridge = "building-bridge",
  Cables = "cables",
  RackDesigns = "rack-designs",
  Storage = "storage",
  Installations = "installations",
  LteBackup = "lte-backup",
  CableInternet = "cable-internet",
  InternetSolutions = "internet-solutions",
  Accessories = "accessories",
  DoorAccess = "door-access",
  DoorAccessIntercoms = "intercoms",
  DoorAccessTouchPass = "door-access-touchpass",
  UpsSolutions = "ups-solutions",
  PowerSolutions = "power-solutions",
  SfpWizard = "sfp-wizard",
  TravelRouter = "travel-router",
  // How It Works
  SmallDeployment = "small-deployment",
  LargeDeployment = "large-deployment",
  MultiSiteDeployment = "multi-site",
  MassiveScaleDeployment = "massive-scale-deployment",
}

export interface IExtendedTab {
  id: ExtendedTabId | string;
  label: TranslationKey;
  image: string;
  href?: string;
}
